export default {
  title: 'Системийн бүртгэл',
  source: 'Холбогдсон инстанс: {{instanceId}} · Файл: {{fileName}}',
  instances: 'Инстансууд',
  localInstance: '{{instanceId}} (холбогдсон)',
  instanceLost: 'Энэ инстанс бүртгэлээ илгээхээ зогсоосон (унтарсан эсвэл холбогдох боломжгүй)',
  status: {
    connecting: 'Холбогдож байна...',
    connected: 'Шууд',
    disconnected: 'Салсан',
  },
  searchPlaceholder: 'Мөр шүүх...',
  levels: {
    error: 'Алдаа',
    warn: 'Анхааруулга',
    info: 'Мэдээлэл',
    debug: 'Дибаг',
  },
  httpRequests: 'HTTP хүсэлтүүд',
  httpRequestsTitle: 'Серверийн боловсруулсан HTTP хүсэлтүүдийн бүртгэлийн мөрүүдийг харуулах эсвэл нуух',
  maxLines: 'Дээд мөр',
  pause: 'Түр зогсоох',
  resume: 'Үргэлжлүүлэх ({{count}} шинэ)',
  export: 'Экспортлох',
  exportTitle: 'Ачаалсан бүх мөрийг (шүүлтүүргүйгээр) текст файл болгон татах',
  clear: 'Цэвэрлэх',
  reconnect: 'Дахин холбогдох',
  jumpToLatest: 'Хамгийн сүүлийнх рүү',
  fileNotFound: 'Инстанс {{instanceId}}: бүртгэлийн файл {{fileName}} олдсонгүй, үүсэхийг хүлээж байна',
  linesCount: '{{total}} мөрөөс {{visible}}-г харуулж байна',
  markers: {
    rotated: 'бүртгэлийн файл солигдсон',
    skipped: 'хэт олон мөр бичигдсэн: зарим мөрийг алгассан',
    truncated: 'хуучин мөрүүдийг ачаалаагүй',
  },
}
